import React from 'react';
import { Lock, LogIn, UserPlus, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

// 비회원 공개 페이지 공용 — 상세 진입 시 로그인/회원가입 유도 모달
function PublicGateModal({ gate, onClose }) {
    const navigate = useNavigate();
    if (!gate) return null;

    return (
        <div style={S.overlay} onClick={onClose}>
            <div style={S.modal} onClick={e => e.stopPropagation()}>
                <button style={S.close} onClick={onClose}><X size={18} /></button>
                <div style={S.icon}><Lock size={26} /></div>
                <h3 style={S.title}>{gate.title}</h3>
                <p style={S.desc}>{gate.desc}</p>
                <div style={S.btns}>
                    <button style={S.signup} onClick={() => navigate('/signup')}>
                        <UserPlus size={16} /> 무료 회원가입
                    </button>
                    <button style={S.login} onClick={() => navigate('/login')}>
                        <LogIn size={16} /> 로그인
                    </button>
                </div>
            </div>
        </div>
    );
}

const S = {
    overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(2,6,23,0.6)', backdropFilter: 'blur(4px)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 20 },
    modal: { position: 'relative', width: '100%', maxWidth: 400, backgroundColor: '#fff', borderRadius: 20, padding: '36px 28px 28px', textAlign: 'center', boxShadow: '0 25px 80px rgba(0,0,0,0.35)' },
    close: { position: 'absolute', top: 14, right: 14, background: 'none', border: 'none', color: '#94a3b8', cursor: 'pointer', padding: 6 },
    icon: { width: 60, height: 60, margin: '0 auto 18px', borderRadius: '50%', backgroundColor: '#eff6ff', color: '#3b82f6', display: 'flex', alignItems: 'center', justifyContent: 'center' },
    title: { margin: '0 0 10px', fontSize: 19, fontWeight: 800, color: '#0f172a' },
    desc: { margin: '0 0 24px', fontSize: 14, lineHeight: 1.7, color: '#64748b' },
    btns: { display: 'flex', flexDirection: 'column', gap: 10 },
    signup: { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, padding: '14px', backgroundColor: '#3b82f6', color: '#fff', border: 'none', borderRadius: 12, fontSize: 15, fontWeight: 700, cursor: 'pointer' },
    login: { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, padding: '13px', backgroundColor: '#f1f5f9', color: '#334155', border: 'none', borderRadius: 12, fontSize: 15, fontWeight: 600, cursor: 'pointer' },
};

export default PublicGateModal;
